'use strict';

var _classCallCheck = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/createClass");

var FeedIndex =
/*#__PURE__*/
function () {
  function FeedIndex() {
    _classCallCheck(this, FeedIndex);

    this._index = {};
  }

  _createClass(FeedIndex, [{
    key: "get",
    value: function get() {
      var _this = this;

      return Object.keys(this._index).map(function (f) {
        return _this._index[f];
      });
    }
  }, {
    key: "updateIndex",
    value: function updateIndex(oplog) {
      var _this2 = this;

      this._index = {};
      oplog.values.reduce(function (handled, item) {
        if (!handled.includes(item.hash)) {
          handled.push(item.hash);

          if (item.payload.op === 'ADD') {
            _this2._index[item.hash] = item;
          } else if (item.payload.op === 'DEL') {
            delete _this2._index[item.payload.value];
          }
        }

        return handled;
      }, []);
    }
  }]);

  return FeedIndex;
}();

module.exports = FeedIndex;